module.exports = __webpack_public_path__ + "static/img/mypage-menu-icon01_hover.7b6c9f35.svg";